export default "__VITE_ASSET__BJHZGA_Y__"